import { render } from "./UsersCreate.vue?vue&type=template&id=199aba24"
import script from "./UsersCreate.vue?vue&type=script&lang=js"
export * from "./UsersCreate.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__